<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <div class="c-document">
        <!-- filter -->
        <config-filter
          ref="queryformRef"
          :gameData="gameData"
          placeholder="请输入分包应用ID"
          @on-change="filterData"
          @on-set="submit"
          @on-config="openConfig"
          @on-export="downData"
          @on-search="searchFilterData"
        />
        <!-- table -->
        <div class="c-table-list">
          <Viewport v-model="tableHeight">
            <config-table
              :loading="tableLoading"
              :height="tableHeight"
              :data="tableList"
              :columns="tableCol"
              @on-edit="submit"
              @on-del="deleteRule"
            />
            <Page
              show-total
              show-sizer
              show-elevator
              :total="total"
              :current.sync="pageIndex"
              :page-size="pageSize"
              :page-size-opts="[10, 20, 30, 40, 100]"
              @on-change="changePageIndex"
              @on-page-size-change="changePageSize"
              size="small"
              class="c-table-page pager"
            />
          </Viewport>
        </div>

        <!-- 弹出框 -->
        <config-set v-model="model" title="配置" :info="info" :edit="edit" :loading="loading" :gameData="gameData" @on-save="save" />

        <!-- 弹出框 -->
        <monitor-set v-model="configModal" title="配置" :info="configInfo" :loading="loading" @on-save="setConfig" />
      </div>
    </Content>
  </Layout>
</template>
<script>
import Cookies from 'js-cookie'
import mixin from './mixin'
import { HOST_API } from '@/api/config'
import columns from '../data/toutiaogame_config_column.js?v=3.0'
import { isArray, isEmpty } from '@/common/js/utils'
import { getPtomGames } from '@/api/material.model'
import {
  getToutiaoGameConfigList,
  getToutiaoGameConfig,
  delToutiaoGameConfig,
  addOrModifyToutiaoGameConfig,
  getMonitorConfig,
  setMonitorConfig
} from '@/api/manage.model'
import ConfigFilter from './components/filter'
import ConfigTable from './components/table'
import ConfigSet from './components/set'
import MonitorSet from './components/config'

const getConfirmForm = () => {
  return {
    d: 0,
    gameId: '',
    mediaId: 10,
    acId: '',
    acType: 'AD',
    appId: '',
    poolSize: '',
    freeSpace: '',
    packageId: undefined,
    notice: true,
    warnRemindOps: []
  }
}

export default {
  name: 'toutiaogameconfig',
  mixins: [mixin],
  components: { ConfigFilter, ConfigTable, ConfigSet, MonitorSet },
  methods: {
    getData(filter) {
      if (this.tableLoading) return
      // 加载状态
      this.tableLoading = true
      // this.$Spin.show()
      let params = {
        page_id: this.pageIndex,
        page_size: this.pageSize
      }
      if (filter) params = Object.assign({}, params, filter)
      this.params = params
      getToutiaoGameConfigList(params)
        .then((data) => {
          // this.$Spin.hide()
          this.tableLoading = false
          if (data) {
            const { list, page_info } = data
            this.tableList = list
            const { page_id, page_size, total_number } = page_info
            this.total = total_number
            this.pageIndex = page_id
            this.pageSize = page_size
          }
        })
        .catch((err) => {
          this.tableLoading = false
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    deleteRule(row) {
      const { id } = row
      delToutiaoGameConfig({ id }).then((data) => {
        if (data) this.$refs.queryformRef.sendEvent()
      })
    },
    closeModal(status) {
      this.configModal = status
    },
    submit(edit) {
      this.edit = !!edit
      if (edit) {
        const { mediaId, gameId } = edit
        this.loading = true
        getToutiaoGameConfig({ mediaId, gameId }).then((data) => {
          this.loading = false
          if (data) {
            const { id, gameId, acId, acType, appId, poolSize, freeSpace, isWarn, warnRemindOps, mediaId, packageId } = data
            this.info = {
              ...getConfirmForm(),
              id,
              gameId,
              acId,
              acType,
              appId,
              poolSize,
              freeSpace,
              packageId,
              mediaId,
              notice: isWarn,
              warnRemindOps: warnRemindOps ? warnRemindOps.split(',').map(Number) : []
            }
            this.model = true
          }
        })
      } else {
        const opId = Cookies.get('ch_op_id')
        this.info = {
          ...getConfirmForm(),
          warnRemindOps: [Number(opId)]
        }
        this.model = true
      }
    },
    save(params) {
      const { packageId, warnRemindOps, notice, ...restParams } = params
      this.loading = true
      addOrModifyToutiaoGameConfig({
        ...restParams,
        // notice 开启或关闭
        warnRemindOps: notice ? warnRemindOps.join(',') : '',
        packageId: restParams.mediaId === 32 ? packageId : undefined
      }).then((data) => {
        this.loading = false
        if (data) {
          // this.getData()
          this.$refs.queryformRef.sendEvent()
          this.model = false
        }
      })
    },
    openConfig() {
      getMonitorConfig().then((res) => {
        this.configInfo = res
        this.configModal = true
      })
    },
    setConfig(params) {
      setMonitorConfig(params).then((res) => {
        if (res) {
          this.$Message.success('操作成功！')
          this.configModal = false
        } else {
          this.$Message.error('操作失败！')
        }
      })
    },
    downData() {
      let url = `${HOST_API}/api/ptom/game/extendpackage/export?`
      this.params.keyword && (url += `&keyword=${this.params.keyword}`)
      this.params.gameId > 0 && (url += `&gameId=${this.params.gameId}`)
      window.open(url)
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.$refs.queryformRef.sendEvent()
    },
    changePageSize(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.$refs.queryformRef.sendEvent()
    },
    preloadData() {
      Promise.all([getPtomGames()])
        .then((data) => {
          const [gameData] = data
          if (isArray(gameData)) {
            this.gameData = gameData.filter((ret) => ret.ch_platform_id === 1)
          }
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    }
  },
  data() {
    return {
      tableHeight: 330,
      total: 0,
      pageIndex: 1,
      pageSize: 20,
      model: false, // 弹窗开关
      configModal: false, // 分包数量监控提醒信息弹窗开关
      configInfo: {}, // 分包数量监控提醒信息
      edit: null,
      info: {},
      gameData: []
    }
  },
  mounted() {
    this.tableCol = columns
    this.preloadData()
    this.$refs.queryformRef.sendEvent()
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
